import "@/App.css";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import Marquee from "@/components/Marquee";
import About from "@/sections/About";
import Method from "@/sections/Method";
import Differentiators from "@/sections/Differentiators";
import Testimonials from "@/sections/Testimonials";
import Location from "@/sections/Location";
import Contact from "@/sections/Contact";
import StickyWhatsApp from "@/sections/StickyWhatsApp";

function App() {
  return (
    <SmoothScroll>
      <div className="App grain">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <About />
          <Method />
          <Differentiators />
          <Marquee reverse />
          <Testimonials />
          <Location />
          <Contact />
        </main>
        <StickyWhatsApp />
      </div>
    </SmoothScroll>
  );
}

export default App;
